import { createSvgIcon } from '@mui/material';

const InventoryVolume = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 7.5L12 3L4 7.5M20 7.5V16.5L12 21M20 7.5L12 12M12 21L4 16.5V7.5M12 21V12M4 7.5L12 12M16 5.25L12 7.5L8 9.75"
      stroke="black"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2611 18.4522L18.4572 15.4522M18.4572 15.4522L17.8962 16.4629M18.4572 15.4522L17.3796 15.4714"
      stroke="#85C440"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5221 19V13M10.5221 13L11.117 13.9912M10.5221 13L10 13.9429"
      stroke="#85C440"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'InventoryVolume',
);

export default InventoryVolume;
